import common from "./common";
import placeholder from "./placeholder";
import message from "./message";
import ai from "./ai";
import login from "./login";
import register from "./register";
import forgotPassword from "./forgotPassword";
import post from "./post";
import channel from "./channel";
import subscription from "./subscription";
import profile from "./profile";
import analytics from "./analytics";
import team from "./team";
import errorPage from "./errorPage";
import media from "./media";
import urlshortener from "./urlshortener";
import preConnect from "./preConnect";
import channelCat from "./channelCat";
import postTag from "./postTag";
import automation from "./automation";
import postCollection from "./postCollection";
import postIdea from "./postIdea";
import scheduledPostDiscussion from "./scheduledPostDiscussion";
import contact from "./contact";
import shortUrl from "./shortUrl";
import postHashtag from "./postHashtag";
import video from "./video";
import shortCode from "./shortCode";
import canva from "./canva";
import aiVoice from "./aiVoice";
import aiAsset from "./aiAsset";
import aiKnowledgeBase from "./aiKnowledgeBase";
import bgmBucket from "./bgmBucket";
import APIKey from "./APIKey";
import uploader from "./uploader";
import socialInbox from "./socialInbox";
export const ja = {
  common,
  placeholder,
  message,
  ai,
  login,
  register,
  forgotPassword,
  post,
  channel,
  subscription,
  profile,
  team,
  errorPage,
  media,
  urlshortener,
  preConnect,
  channelCat,
  postTag,
  automation,
  postCollection,
  postIdea,
  scheduledPostDiscussion,
  contact,
  shortUrl,
  postHashtag,
  video,
  shortCode,
  canva,
  aiVoice,
  aiAsset,
  aiKnowledgeBase,
  bgmBucket,
  APIKey,
  uploader,
  socialInbox,
  analytics
};
